import { createFileRoute } from "@tanstack/react-router";
import UaMsEmployeePlanInsurance, {
  config,
} from "@/pages/UaMsEmployeePlanInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/ua-ms-employee-plan-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "UA MS Employee Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "UnitedHealthcare MS employee plan coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "UA MS Employee Plan TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "UnitedHealthcare MS employee plan coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/ua-ms-employee-plan-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ua-ms-employee-plan-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <UaMsEmployeePlanInsurance />;
}
